export default "__VITE_ASSET__Bm3092s3__"